import React from 'react'
import { HashRouter as Router, Routes, Route, Link } from 'react-router-dom'
import { Container, Navbar, Nav, Row, Col, ListGroup } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import './themes.css'
import { ThemeProvider } from './contexts/ThemeContext'
import ThemeToggle from './components/ThemeToggle'
import LoginIcon from './components/LoginIcon'
import Home from './pages/Home'
import Contact from './pages/Contact'
import Chat from './pages/Chat'
import MathOperations from './pages/MathOperations'
import SampleApi from './pages/SampleApi'
import AfterLogin from './pages/AfterLogin'
import UserInfo from './pages/UserInfo'
import Recents from './pages/Recents'
import Favorites from './pages/Favorites'
import Flagged from './pages/Flagged'

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Navbar bg="dark" variant="dark" expand="lg">
            <Container fluid>
              <Navbar.Brand as={Link} to="/">DSRAG</Navbar.Brand>
              <div className="d-flex align-items-center">
                <LoginIcon />
                <ThemeToggle />
              </div>
            </Container>
          </Navbar>

        <Container fluid className="mt-4">
          <Row>
            <Col md={2} className="bg-light p-3">
              <h5>Navigation</h5>
              <ListGroup variant="flush">
                <ListGroup.Item
                  as={Link}
                  to="/"
                  action
                  className="border-0 bg-transparent"
                >
                  Home
                </ListGroup.Item>
                <ListGroup.Item
                  as={Link}
                  to="/chat"
                  action
                  className="border-0 bg-transparent"
                >
                  Chat
                </ListGroup.Item>
                <ListGroup.Item
                  as={Link}
                  to="/favorites"
                  action
                  className="border-0 bg-transparent"
                >
                  Favorites
                </ListGroup.Item>
                <ListGroup.Item
                  as={Link}
                  to="/recents"
                  action
                  className="border-0 bg-transparent"
                >
                  Recents
                </ListGroup.Item>
                <ListGroup.Item
                  as={Link}
                  to="/flagged"
                  action
                  className="border-0 bg-transparent"
                >
                  Flagged
                </ListGroup.Item>
                <ListGroup.Item
                  as={Link}
                  to="/math"
                  action
                  className="border-0 bg-transparent"
                >
                  Math Operations
                </ListGroup.Item>
                <ListGroup.Item
                  as={Link}
                  to="/sample-api"
                  action
                  className="border-0 bg-transparent"
                >
                  Sample API
                </ListGroup.Item>
                <ListGroup.Item
                  as={Link}
                  to="/userinfo"
                  action
                  className="border-0 bg-transparent"
                >
                  User Info
                </ListGroup.Item>
                <ListGroup.Item
                  as={Link}
                  to="/contact"
                  action
                  className="border-0 bg-transparent"
                >
                  Contact
                </ListGroup.Item>
              </ListGroup>
            </Col>
            
            <Col md={10} className="p-4">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/chat" element={<Chat />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/math" element={<MathOperations />} />
                <Route path="/sample-api" element={<SampleApi />} />
                <Route path="/afterlogin" element={<AfterLogin />} />
                <Route path="/userinfo" element={<UserInfo />} />
                <Route path="/recents" element={<Recents />} />
                <Route path="/favorites" element={<Favorites />} />
                <Route path="/flagged" element={<Flagged />} />
              </Routes>
            </Col>
          </Row>
        </Container>
      </div>
    </Router>
    </ThemeProvider>
  )
}

export default App